export default "/_next/static/images/d27f15bfa42d229a7067dec367710b56.png";